import CommonState from './CommonState'
import { getStateByCode } from './CommonState'

/**
 * 箱货信息静态变量类
 */
export class ManifestGoodsInfoConstants {
  /**
 * 箱货信息常量定义
 */
  static CREATED = new CommonState(0, '未发送', 'Created')
  static SENDED = new CommonState(1, '已发送', 'Sended')
  static SUCCEEDED = new CommonState(2, '已成功', 'Succeeded')
  static FAIED = new CommonState(3, '已失败', 'Failed')
  static REPAIR_SUCCEEDED = new CommonState(3, '未发送', 'RepairSucceeded')
  /**
   * 箱货信息EDI发送状态
   */
  static EDI_STATUS = [this.CREATED, this.SENDED, this.SUCCEEDED, this.FAIED, this.REPAIR_SUCCEEDED]
  /**
   * 根据代码获取状态
   * @param {Number} code
   */
  static getStateByCode(code) {
    return getStateByCode(this.EDI_STATUS, code)
  }
}
